import { useState, useEffect } from 'react';
import { getContext } from '@/context';
import { fetchUserAvatar, DEFAULT_AVATAR } from '@/requests/user/userProfile';
import { getUserTier } from '@/features/credits';
import useAuth from './useAuth';

const useUserProfile = () => {
  const { isAuthorized } = useAuth();

  const [username, setUsername] = useState('');
  const [userId, setUserId] = useState<number | null>(null);
  const [avatarSrc, setAvatarSrc] = useState(DEFAULT_AVATAR);
  const [tierId, setTierId] = useState<string | null>(null);

  useEffect(() => {
    if (!isAuthorized) {
      setUsername('');
      setUserId(null);
      setAvatarSrc(DEFAULT_AVATAR);
      setTierId(null);
      return;
    }

    const { username: name, id } = getContext().general.auth.getState();
    setUsername(name ?? '');
    setUserId(id ?? null);

    if (!id) return;

    let cancelled = false;

    Promise.all([fetchUserAvatar(id), getUserTier()]).then(([avatar, tier]) => {
      if (cancelled) return;
      setAvatarSrc(avatar);
      if (tier) setTierId(tier.id);
    });

    return () => {
      cancelled = true;
    };
  }, [isAuthorized]);

  return {
    isAuthorized: isAuthorized ?? false,
    username,
    userId,
    avatarSrc,
    tierId,
  };
};

export default useUserProfile;
